export enum SearchSuggestionsErrors {
    Default = 'SEARCH_SUGGESTIONS_ERROR',
}
